// extracted by mini-css-extract-plugin
export var addButton = "_5p-d";
export var bullets = "_5p-e";
export var compact = "_5p-2";
export var container = "_5p-j";
export var extendedWarrantyModal = "_5p-f";
export var learn = "_5p-l";
export var learnMore = "_5p-g";
export var offeringOption = "_5p-3";
export var offeringPrice = "_5p-8";
export var offeringSubtitle = "_5p-7";
export var offeringTitle = "_5p-6";
export var offeringsContainer = "_5p-0";
export var pdpTilesBackground = "_5p-n";
export var plan = "_5p-m";
export var regular = "_5p-1";
export var remove = "_5p-k";
export var seeDetailsIcon = "_5p-i";
export var seeDetailsLink = "_5p-h";
export var selectedOption = "_5p-4";
export var shieldIcon = "_5p-b";
export var shieldIconCompact = "_5p-c";
export var subtitle = "_5p-a";
export var title = "_5p-9";
export var unselectedOption = "_5p-5";